module.exports = __webpack_public_path__ + "static/media/duck-confused.1657bed1.gif";